
@if(isDataLoaded){

<!-- ── Modal Header ── -->
<div class="reschedule-modal-header">
  <div class="reschedule-header-icon-box">
    <ion-icon name="refresh-circle-outline"></ion-icon>
  </div>
  <div class="reschedule-header-copy">
    <ion-text class="reschedule-header-kicker">Activity Update</ion-text>
    <h2 class="reschedule-header-title">{{ data.PropertyActivity.ActivityType }}</h2>
  </div>
  <button class="reschedule-close-btn" (click)="closeDialog()" aria-label="Close dialog">
    <ion-icon name="close-outline"></ion-icon>
  </button>
</div>

<!-- ── Modal Body ── -->
<div class="reschedule-modal-body">

  <!-- Info Card -->
  <ion-card class="info-card">
    <ion-card-content>
      <div class="info-row">
        <div class="info-icon-box">
          <ion-icon name="information-circle-outline"></ion-icon>
        </div>
        <ion-text class="info-text">
          Mark your last activity as <strong>Done</strong> to complete it, or <strong>Cancel</strong> to remove it from your schedule.
        </ion-text>
      </div>
    </ion-card-content>
  </ion-card>

  <!-- Status Selection Cards -->
  <ion-text class="section-label">
    <ion-icon name="radio-button-on-outline"></ion-icon>
    Select Activity Outcome
  </ion-text>

  <ion-radio-group [(ngModel)]="itemChecked" (ionChange)="onSelectEvent($event.detail.value)">
    <div class="status-cards-grid">

      <!-- Done Option -->
      <ion-card class="status-card" [class.status-card--selected]="itemChecked === 'Done'"
        (click)="itemChecked = 'Done'; onSelectEvent('Done')" role="button" tabindex="0"
        (keydown.enter)="itemChecked = 'Done'; onSelectEvent('Done')">
        <ion-card-content>
          <div class="status-card-top">
            <div class="status-icon-box status-icon-box--done">
              <ion-icon name="checkmark-circle-outline"></ion-icon>
            </div>
            <ion-radio value="Done" class="status-radio"></ion-radio>
          </div>
          <ion-text class="status-card-title">Done</ion-text>
          <ion-text class="status-card-caption">Activity completed successfully</ion-text>
        </ion-card-content>
      </ion-card>

      <!-- Cancel Option -->
      <ion-card class="status-card" [class.status-card--selected]="itemChecked === 'Cancel'"
        (click)="itemChecked = 'Cancel'; onSelectEvent('Cancel')" role="button" tabindex="0"
        (keydown.enter)="itemChecked = 'Cancel'; onSelectEvent('Cancel')">
        <ion-card-content>
          <div class="status-card-top">
            <div class="status-icon-box status-icon-box--cancel">
              <ion-icon name="close-circle-outline"></ion-icon>
            </div>
            <ion-radio value="Cancel" class="status-radio"></ion-radio>
          </div>
          <ion-text class="status-card-title">Cancel</ion-text>
          <ion-text class="status-card-caption">Remove from schedule</ion-text>
        </ion-card-content>
      </ion-card>

    </div>
  </ion-radio-group>

  <!-- Footer Action -->
  <div class="reschedule-footer">
    <ion-button expand="block" class="btn-submit" [disabled]="!isFormDisable" (click)="nextActivity()">
      <ion-icon name="arrow-forward-circle-outline" slot="start"></ion-icon>
      Confirm &amp; Proceed
    </ion-button>
  </div>

</div>

}